/* ==========================================================
   product-filter.js
   Part 1/3
   Depends on product-filter-common.js
   ========================================================== */

(function ($) {

    "use strict";

    $(function () {

        if (typeof ProductFilterCommon === "undefined") {
            console.error("ProductFilterCommon is not loaded");
            return;
        }

        ProductFilterCommon.initialize();


        let slideToggleSpeed = 200;


        let appliedFilterObject =
            ProductFilterCommon.appliedFilterObject;



        let $filterCheckboxes =
            $('.product-filter-btn');



        /* -------------------------------------------------------
           Accordion
        ------------------------------------------------------- */


        let isHandlingKeyboardEvent = false;


        $('.ab_accordion_header')
            .on('click keypress', function (event) {


                if (isHandlingKeyboardEvent) {

                    return;

                }



                if (
                    event.type === "click" ||
                    (
                        event.type === "keypress" &&
                        event.key === "Enter"
                    )
                ) {


                    isHandlingKeyboardEvent = true;



                    let $this = $(this);


                    let $content =
                        $this.siblings('.ab_accordion_content');



                    let isActive =
                        $this.hasClass('activeFilter');



                    $('.ab_accordion_content')
                        .not($content)
                        .slideUp(slideToggleSpeed);



                    $('.ab_accordion_header')
                        .not($this)
                        .removeClass('activeFilter');



                    $content.slideToggle(slideToggleSpeed);



                    $this.toggleClass(
                        'activeFilter',
                        !isActive
                    );



                    $this.attr(
                        'aria-expanded',
                        !isActive
                    );



                    $content.attr(
                        'aria-hidden',
                        isActive
                    );



                    setTimeout(function () {


                        isHandlingKeyboardEvent = false;


                    }, 300);



                }



            });




        /* -------------------------------------------------------
           Close Accordion Outside Click
        ------------------------------------------------------- */


        $(document)
            .on('mouseup', function (e) {


                if (
                    !$(".ab_accordion_header").is(e.target) &&
                    $(".ab_accordion_content")
                        .has(e.target)
                        .length === 0
                ) {


                    $('.ab_accordion_content')
                        .slideUp(slideToggleSpeed);



                    $('.ab_accordion_header')
                        .removeClass('activeFilter');


                }



            });




        /* -------------------------------------------------------
           Mobile Filter Open / Close
        ------------------------------------------------------- */


        $('.close-icon, .product-filter-apply')
            .on('click', function () {



                setTimeout(function () {


                    ProductFilterCommon.hideZeroCard();


                }, 800);



                $(this)
                    .parents('.js-product-filter')
                    .removeClass(
                        'product-filter--is-active'
                    );



                $('body')
                    .removeClass(
                        'overflow-hidden'
                    );



            });




        $('.product-filter-toggle-mobile, .product-filter-toggle-label')
            .on('click', function () {


                $(this)
                    .parents('.js-product-filter')
                    .addClass(
                        'product-filter--is-active'
                    );



                $('body')
                    .addClass(
                        'overflow-hidden'
                    );



                $('.product-filter-item')
                    .removeClass(
                        'accordion-expanded'
                    );



                $('.accordion-title i')
                    .removeClass(
                        'icon-arrow-up'
                    )
                    .addClass(
                        'icon-arrow-down'
                    );



            });




        /* -------------------------------------------------------
           Filter Button Click
        ------------------------------------------------------- */


        $filterCheckboxes
            .on('click', function () {


                let selectedFilters =
                    ProductFilterCommon.getSelectedFilters();



                $(this)
                    .toggleClass(
                        'product-filter-btn--is-active'
                    );



                $('.ProductFamily--Row')
                    .addClass(
                        'opacityClass'
                    );



                setTimeout(function () {


                    $('.ProductFamily--Row')
                        .removeClass(
                            'opacityClass'
                        );


                }, 900);



                selectedFilters =
                    ProductFilterCommon.getSelectedFilters();




                if (
                    window.matchMedia(
                        '(min-width:991px)'
                    ).matches
                ) {



                    ProductFilterCommon.applyFilter(
                        selectedFilters
                    );



                    ProductFilterCommon.storeAppliedFilters(
                        selectedFilters
                    );



                    $('.product-filter-applied-list')
                        .empty();



                    $('.product-filter-btn--is-active')
                        .each(function () {


                            let label =
                                $(this).text();



                            $('.product-filter-applied-list')
                                .append(
                                    '<button aria-label="selected filter label" class="activeFilterLable">' +
                                    label +
                                    '<i class="icon icon-validation-cross"></i>' +
                                    '</button>'
                                );



                            $('.clear-tags')
                                .css(
                                    'display',
                                    'inline-block'
                                );



                        });



                } else {



                    ProductFilterCommon.applyFilterMobCta(
                        selectedFilters
                    );



                    ProductFilterCommon.updateFilterText4MobBtn();



                    ProductFilterCommon.disableEmptyCategories(
                        selectedFilters
                    );



                    ProductFilterCommon.activeLabelAppend(
                        selectedFilters
                    );



                    ProductFilterCommon.disableParent();



                }



                /* accessibility */

                let filterName =
                    $(this)
                        .data('filter-name');



                let isPressed =
                    $(this)
                        .attr('aria-pressed') === "true";



                $(this)
                    .attr(
                        'aria-pressed',
                        !isPressed
                    );



                if ($("#filterStatus").length === 0) {


                    $("body")
                        .append(
                            '<div id="filterStatus" aria-live="assertive" aria-atomic="true" class="sr-only"></div>'
                        );


                }



                $("#filterStatus")
                    .text(
                        `${filterName} filter ${!isPressed ? "selected" : "deselected"}`
                    );



            });



    });

    /* ==========================================================
       product-filter.js
       Part 2/3
       ========================================================== */


    /* -------------------------------------------------------
       Applied Filter Label Remove
    ------------------------------------------------------- */


    $(document).on(
        'click',
        '.activeFilterLable',
        function () {


            let removedLabel =
                $(this)
                    .text()
                    .trim();



            $(this).remove();



            $('.product-filter-btn')
                .each(function () {


                    if (
                        $(this)
                            .text()
                            .trim() === removedLabel
                    ) {


                        $(this)
                            .removeClass(
                                'product-filter-btn--is-active'
                            );


                        $(this)
                            .attr(
                                'aria-pressed',
                                'false'
                            );


                    }


                });



            let selectedFilters =
                ProductFilterCommon.getSelectedFilters();



            if (
                Object.keys(selectedFilters).length === 0
            ) {


                $('.product-filter-applied-list')
                    .empty();



                $('.clear-tags')
                    .css(
                        'display',
                        'none'
                    );


            }



            ProductFilterCommon.applyFilter(
                selectedFilters
            );



            ProductFilterCommon.applyFilterMobCta(
                selectedFilters
            );



            ProductFilterCommon.updateFilterText4MobBtn();



            ProductFilterCommon.updateCategoryCount();



            ProductFilterCommon.activeLabelAppend(
                selectedFilters
            );



            ProductFilterCommon.disableEmptyCategories(
                selectedFilters
            );



            ProductFilterCommon.disableParent();



        });




    /* -------------------------------------------------------
       Close Button Restore Applied Filters
    ------------------------------------------------------- */


    $('.close-icon')
        .on('click', function () {


            let appliedFilters =
                ProductFilterCommon.appliedFilterObject;



            if (
                Object.keys(appliedFilters).length === 0
            ) {



                let emptyFilters = {};



                ProductFilterCommon.applyFilter(
                    emptyFilters
                );



                ProductFilterCommon.updateCategoryCount();



                return;


            }



            $('.product-filter-btn')
                .removeClass(
                    'product-filter-btn--is-active'
                );



            $('.filter-tags')
                .empty();



            $('.disabled')
                .removeClass(
                    'disabled'
                )
                .prop(
                    'disabled',
                    false
                );



            $.each(
                appliedFilters,
                function (_group, values) {


                    $.each(
                        values,
                        function (_index, value) {



                            $('.product-filter-btn')
                                .each(function () {



                                    let btnValue =
                                        $(this)
                                            .attr(
                                                'data-filter-name'
                                            )
                                            .toLowerCase();



                                    if (
                                        btnValue ===
                                        value.toString()
                                    ) {


                                        $(this)
                                            .addClass(
                                                'product-filter-btn--is-active'
                                            );


                                    }



                                });



                        }
                    );



                }
            );



            ProductFilterCommon.applyFilter(
                appliedFilters
            );



            ProductFilterCommon.activeLabelAppend(
                appliedFilters
            );



            ProductFilterCommon.disableParent();



            ProductFilterCommon.updateCategoryCount();



        });





    /* -------------------------------------------------------
       Mobile Apply Button
    ------------------------------------------------------- */


    $('.js-product-filter-apply')
        .on('click', function () {


            let selectedFilters =
                ProductFilterCommon.getSelectedFilters();



            ProductFilterCommon.storeAppliedFilters(
                selectedFilters
            );



            $('.product-filter-applied-list')
                .empty();



            $('.product-filter-btn--is-active')
                .each(function () {


                    $('.product-filter-applied-list')
                        .append(
                            '<button aria-label="selected filter label" class="activeFilterLable">' +
                            $(this).text() +
                            '<i class="icon icon-validation-cross"></i>' +
                            '</button>'
                        );


                });



            if (
                $('.product-filter-btn--is-active').length
            ) {


                $('.clear-tags')
                    .css(
                        'display',
                        'inline-block'
                    );


            } else {


                $('.clear-tags')
                    .css(
                        'display',
                        'none'
                    );


            }



            ProductFilterCommon.applyFilter(
                selectedFilters
            );



            ProductFilterCommon.updateCategoryCount();



            ProductFilterCommon.updateFilterText4MobBtn();



        });





    /* -------------------------------------------------------
       Reset All Filters
    ------------------------------------------------------- */


    $('.js-product-filter-reset-all, .clear-tags')
        .on('click', function (e) {



            e.preventDefault();



            let emptyFilters = {};



            ProductFilterCommon.appliedFilterObject =
                {};



            ProductFilterCommon.resetFilterUI();



            $('.clear-tags')
                .css(
                    'display',
                    'none'
                );



            ProductFilterCommon.applyFilter(
                emptyFilters
            );



            ProductFilterCommon.updateCategoryCount();



            ProductFilterCommon.updateFilterText4MobBtn();



            ProductFilterCommon.disableParent();



        });





    /* -------------------------------------------------------
       Mobile Filter Bar Count
    ------------------------------------------------------- */


    $('.product-filter-mobile-bar')
        .on(
            'click keypress',
            function () {


                ProductFilterCommon.calculateMobileTotalCount();


            }
        );

    /* ==========================================================
   product-filter.js
   Part 3/3
   ========================================================== */


    /* -------------------------------------------------------
       GA4 Mobile Filter Applied
    ------------------------------------------------------- */


    let isDataLayerTriggered = false;


    $('.product-filter-apply')
        .on('click', function () {


            setTimeout(function () {


                if (!isDataLayerTriggered) {


                    let totalMobCount =
                        $('.mobActiveProductsCount')
                            .text();



                    let activeFilterMobString =
                        ProductFilterCommon.getActiveFilterString();



                    ProductFilterCommon.GA4FilterMobApplied(
                        totalMobCount,
                        activeFilterMobString
                    );



                }



            }, 300);



        });




    /* -------------------------------------------------------
       GA4 Desktop Filter Applied
    ------------------------------------------------------- */


    $('.product-filter-btn')
        .on('click', function () {


            if (
                $(this)
                    .hasClass(
                        'product-filter-btn--is-active'
                    )
            ) {



                if (
                    window.matchMedia(
                        '(min-width:991px)'
                    ).matches
                ) {



                    let totalCount =
                        $('.productCount')
                            .text();



                    let activeFilterValuesString =
                        ProductFilterCommon.getActiveFilterString();



                    ProductFilterCommon.GA4FilterApplied(
                        totalCount,
                        activeFilterValuesString
                    );


                }



            }



        });




    /* -------------------------------------------------------
       Resize Reset
    ------------------------------------------------------- */


    window.addEventListener(
        'resize',
        function () {


            if (
                window.matchMedia(
                    '(max-width:990px)'
                ).matches &&
                isDataLayerTriggered === false
            ) {


                isDataLayerTriggered = false;


            }


        }
    );





    /* -------------------------------------------------------
       Product Text Height Reset
    ------------------------------------------------------- */


    $('.js-product-filter-apply, .close-icon')
        .on(
            'click',
            function () {


                $('.productBoxMain .productBoxText .title, .productBoxMain .productBoxText .paraDiv, .productBoxMain .productBoxText .js-review')
                    .css(
                        'height',
                        'auto'
                    );


            }
        );





    /* -------------------------------------------------------
       Global Filter UI Refresh
    ------------------------------------------------------- */


    $(
        '.Tags__Button, .tag_Menu_Button, .js-product-filter-btn, .clear-tags, .js-product-filter-applied-list, .js-product-filter-reset-all'
    )
        .on(
            'click keypress',
            function () {



                ProductFilterCommon.refreshFilterUI();



            }
        );





    /* -------------------------------------------------------
       Initial UI Updates
    ------------------------------------------------------- */


    $(function () {


        ProductFilterCommon.updateFilterText();


        ProductFilterCommon.updateFilterText4MobBtn();


        ProductFilterCommon.updateCategoryCount();


        ProductFilterCommon.disableParent();


    });



})(jQuery);